import { Injectable } from "@angular/core";
import { Adapter } from "src/app/core/adapter";

export class Language {

    constructor(
        public label:string,
        public value: string,
    ) {}
}

    @Injectable({
        providedIn: "root"
    })

    export class LanguageAdapter implements Adapter<Language> {
        adapt(item:any): Language {
            return new Language(item.description,item.locale);
       }
    }

